import type { i18n as I18n } from 'i18next'

/**
 * Tient `<html lang>` aligné sur la langue de l'interface (RGAA 8.3/8.4).
 *
 * Sans ça, la page restait déclarée `en` quelle que soit la langue affichée :
 * un lecteur d'écran lisait toute l'interface française avec une voix anglaise.
 */
export function bindDocumentLanguage(instance: I18n, root: HTMLElement = document.documentElement): void {
  // La langue résolue (celle dont les textes sont réellement affichés), pas la
  // demandée : `fr-CA` sans traduction propre s'affiche en `fr`.
  const apply = (requested?: string) => {
    const language = instance.resolvedLanguage ?? requested
    if (language) root.lang = language
  }
  apply(instance.language)
  instance.on('languageChanged', apply)
}
